import {
    valid,
    refreshToken,
    ajax,
    serviceAjax,
    header
} from './base'
import config from '../../config';
const freight = {
    // Freight
    async GetFreightList(data = {}) {
        const response = await serviceAjax({
            url: '/api/services/app/Freight/GetPaged',
            type: 'post',
            data
        })
        return response
    },
    async AddOrUpdateFreight(data = {}) {
        const response = await serviceAjax({
            url: '/api/services/app/Freight/CreateOrUpdate',
            type: 'post',
            data
        })
        return response
    },
    async ActiveFreight(data = {}) {
        const response = await serviceAjax({
            url: '/api/services/app/Freight/IsActiveOpt',
            type: 'post',
            data
        })
        return response
    },
    async GetFreight(data = {}) {
        const response = await serviceAjax({
            url: '/api/services/app/Freight/GetById',
            type: 'get',
            data
        })
        return response
    },
    async GetFreightSelect(data = {}) {
        const response = await serviceAjax({
            url: '/api/services/app/Freight/GetFreightForSelect',
            type: 'get',
            data
        })
        return response
    },
    async DelFreight(data = {}) {
        const response = await serviceAjax({
            url: '/api/services/app/Freight/Delete',
            type: 'post',
            data
        })
        return response
    },
    async SetFreight(data = {}) {
        const response = await serviceAjax({
            url: '/api/services/app/Freight/SetFreight',
            type: 'post',
            data
        })
        return response
    },
    async getFreightRecordPaged(data = {}) {
        const response = await serviceAjax({
            url: '/api/services/app/Freight/GetFreightRecordPaged',
            type: 'post',
            data
        })
        return response
    },
    async delFreightRecord(data = {}) {
        const response = await serviceAjax({
            url: '/api/services/app/Freight/Delete',
            type: 'get',
            data
        })
        return response
    }
}

export default freight



// WEBPACK FOOTER //
// ./src/common/api/freight.js